import { useForm } from "react-hook-form";
import { JoinContainer } from "../../style/main/main";
import Select, { SingleValue } from "react-select";
import { useState } from "react";
import { fetchNewCompanyRegist } from "../../api/auth";
import { formatPhoneNumber } from "../../util/util";

const storageOptions = [
  { value: "", label: "신청할 용량을 선택하세요.", isDisabled: true }, // placeholder
  { value: "100", label: "100G" },
  { value: "300", label: "300G" },
  { value: "500", label: "500G" },
  { value: "1000", label: "1T" },
];

const accountOptions = [
  { value: "", label: "신청할 계정 수를 선택하세요.", isDisabled: true },
  { value: "10", label: "10" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
  { value: "300", label: "300" },
  { value: "unlimited", label: "무제한" },
];

interface OptionType {
  value: string;
  label: string;
  isDisabled?: boolean;
}

export interface CompanyRegisterDTO {
  newCompanyCode: string; // 회사 코드
  companyName: string; // 회사 이름
  adminUserAccount: string; // 관리자 계정 (아이디)
  adminPassword: string; // 관리자 비밀번호
  department: string; // 부서
  jobPosition: string; // 직위
  username: string; // 관리자 이름
  userEmail: string; // 관리자 이메일
  storageVolume: number; // 스토리지 용량 (단위: GB 등)
  accountNumLimit: number; // 계정 수 제한
  phoneNumber: string;
}

const Join = () => {
  const { register, handleSubmit } = useForm();
  const [selectedStorage, setSelectedStorage] =
    useState<SingleValue<OptionType>>(null);
  const [selectedAccount, setSelectedAccount] =
    useState<SingleValue<OptionType>>(null);

  const onSubmit = async (data: any) => {
    if (!selectedStorage || !selectedAccount) {
      alert("용량과 계정 수를 모두 선택해주세요.");
      return;
    }

    // ✅ DTO로 매핑
    // newCompanyCode가 현재 하드 코딩으로 동일하여 추가 생성이 불가함.
    // input에 임의로 companyCode를 넣을 수 없음.
    const params: CompanyRegisterDTO = {
      newCompanyCode: "test001", // 회사코드 생성 규칙 예시
      companyName: data.companyName,
      adminUserAccount: data.email, // 이메일을 계정 ID로 사용한다고 가정
      adminPassword: "TempPass!23", // 초기 비밀번호는 정책에 따라 별도 처리
      department: "관리부서", // 현재 폼에는 없음 → 기본값
      jobPosition: "담당자", // 현재 폼에는 없음 → 기본값
      username: data.managerName,
      userEmail: data.email,
      storageVolume: Number(selectedStorage.value),
      accountNumLimit: Number(selectedAccount.value),
      phoneNumber: data.phoneNumber,
      // newCompanyCode: "dddd9999",
      // companyName: "dddd9999-company",
      // adminUserAccount: "dddd9999-admin",
      // adminPassword: "123456789",
      // department: "test",
      // jobPosition: "test",
      // phoneNumber: "010-0000-0000",
      // username: "tester",
      // userEmail: "tester@gmail.com",
      // storageVolume: 100,
      // accountNumLimit: 5,
    };

    console.log(params);

    try {
      const res = await fetchNewCompanyRegist(params);
      console.log("✅ 서비스 신청 성공:", res);

      const parsedMessage = JSON.parse(res.message); // 문자열 → 객체 변환
      console.log("📌 파싱된 메시지:", parsedMessage);

      if (res.status === 200 && parsedMessage.status === "success") {
        alert(`서비스 신청이 완료되었습니다!`);
      } else if (
        res.status === 409 &&
        parsedMessage.status === "already company.."
      ) {
        alert("이미 등록된 회사입니다.");
      } else {
        alert("알 수 없는 응답이 반환되었습니다.");
      }
    } catch (err: any) {
      console.error("❌ 서비스 신청 실패:", err);
      alert("서비스 신청에 실패했습니다. 다시 시도해주세요.");
    }
  };

  return (
    <JoinContainer>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="join-form">
          <h3>서비스 신청</h3>
          <div className="form-box">
            <div className="input-box">
              <input
                type="text"
                {...register("companyName")}
                placeholder="기업명을 입력하세요."
              />
            </div>
            <div className="input-box">
              <input
                type="text"
                {...register("managerName")}
                placeholder="담당자 이름을 입력하세요."
              />
            </div>
            <div className="input-box">
              <input
                type="text"
                {...register("phoneNumber")}
                placeholder="전화번호를 입력하세요."
                onChange={(e) => {
                  e.target.value = formatPhoneNumber(e.target.value);
                }}
              />
            </div>
            <div className="input-box">
              <input
                type="email"
                {...register("email")}
                placeholder="이메일을 입력하세요."
              />
            </div>
            <div className="select-box">
              <Select
                className="join-select"
                classNamePrefix="react-select"
                options={storageOptions}
                value={selectedStorage}
                onChange={(option) => option && setSelectedStorage(option)}
                components={{ IndicatorSeparator: () => null }}
                placeholder="신청할 용량을 선택하세요." // 선택 전 placeholder 텍스트
              />
            </div>
            <div className="select-box">
              <Select
                className="join-select"
                classNamePrefix="react-select"
                options={accountOptions}
                value={selectedAccount}
                onChange={(option) => option && setSelectedAccount(option)}
                components={{ IndicatorSeparator: () => null }}
                placeholder="신청할 계정 수를 선택하세요." // 선택 전 placeholder 텍스트
              />
            </div>
          </div>
          <div className="submit-box">
            <button type="submit">신청하기</button>
          </div>
        </div>
      </form>
      <div className="list-info-item">
        <ul>
          <li>
            <b></b> 안녕하세요, 스피드 백업 서비스 신청 페이지를 방문해
            <br /> 주셔서 감사합니다.
          </li>
          <li>
            <b></b> 스피드 백업은 기업용 클라우드 백업/복원 솔루션입니다.
          </li>
          <li>
            <b></b> 스피드 백업을 경험하고자 하시면 신청 정보를
            <br /> 입력하여 신청하시기 바랍니다.
          </li>
        </ul>
      </div>
    </JoinContainer>
  );
};

export default Join;
